import { ReactNode } from 'react'
import { CommonGuardProps } from './types'
import { useAuthContext } from './useAuthContext'

export default function Authenticated(props: CommonGuardProps): ReactNode {
  const { children, fallback = null } = props
  const { isAuthenticated, company } = useAuthContext()

  if (!isAuthenticated || !company) {
    return fallback
  }

  return children
}
